import { CompanyDTO, CompanyOptimizedDTO } from "./company.dto";
import { EducationalOrganizationsDTO, EducationalOrganizationsOptimizedDTO } from "./educational-organizations.dto";

export enum ENTITY_TYPE {
    SPO = "college",
    UNIVERSITY = "university",
    COMPANY = "company",
    RMR = "rmr",
};

export interface SelectedOrg extends EducationalOrganizationsOptimizedDTO {
    longitude: number;
    latitude: number;
};

export interface SelectedComp extends CompanyOptimizedDTO {
    longitude: number;
    latitude: number;
};

export interface HoveredOrg extends Pick<SelectedOrg, 'latitude' | 'longitude' | 'shortName' | 'id'> { };
export interface HoveredComp extends Pick<SelectedComp, 'latitude' | 'longitude' | 'name' | 'id'> { };
export interface HoveredRMR extends HoveredComp {};

export interface SelectedCluster {
    id: number;
    longitude: number;
    latitude: number;
    count: number;
    isMixed: boolean;
    entitiesInfo: {
        name: string;
        entityType: ENTITY_TYPE;
        id: string;
    }[];
};